import React from "react";
import Herosection from "../components/projectmanagement/Herosection";
import Services from "../components/projectmanagement/Services";
import Section3 from "../components/projectmanagement/Section3";
import Projectmanagement from "../components/projectmanagement/Projectmanagement";
import SEO from "../components/SEO";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Project Management Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in",
  },
  description:
    "Professional project management services including planning, execution, tracking, and delivery optimization.",
};

const ProjectManagement = () => {
  return (
    <>
      <SEO
        title="Publishing & Manuscript Project Management Services | Transforma Pvt Ltd"
        description="End-to-end publishing project management including manuscript tracking, copyediting, proofreading, typesetting, coordination, and on-time final delivery for authors, editors, and publishers."
        keywords="manuscript management, publishing project management, copyediting services, proofreading services, typesetting, book production workflow, editorial coordination, manuscript tracking"
        canonical="https://www.transforma.in/projectmanagement"
        schema={organizationSchema}
      />
      <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
        <Herosection />
        <Services />
        <Section3 />
        <Projectmanagement />
      </div>
    </>
  );
};

export default ProjectManagement;
